import { Node, mergeAttributes } from '@tiptap/core';
export const AdReference = Node.create({
    name: 'adReference',
    group: 'block',
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            platformAdUUIDs: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-platform-ad-uuids': attrs.platformAdUUIDs.join(',') };
                },
                parseHTML(element) {
                    const uuids = element.getAttribute('data-platform-ad-uuids');
                    return uuids?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setAdReference: (platformAdUUIDs) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: { platformAdUUIDs },
                });
            },
            showAdPicker: () => () => {
                this.options.showAdPicker();
                return true;
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-reference',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-reference', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=ad-reference.js.map